export default __webpack_public_path__ + "static/german-48a7664482d734cc83d285c2a882b0f1.jpg";